import React from 'react';
import PageTemplate from '../../components/template/PageTemplate';
import ProductAllListContainer from '../../containers/product/ProductAllListContainer';
import { PRODUCT_PAGE_NAME } from '../../constants/service/app/productConstants';

const ProductAllList = () => {
  return (
    <PageTemplate pageName={PRODUCT_PAGE_NAME.PRODUCT_ALL_LIST}>
      <ProductAllListContainer />
    </PageTemplate>
  );
};

export default ProductAllList;
